const UTM_STORAGE_KEY = "isov_utm";
const LATEST_UTM_STORAGE_KEY = "isov_latest_utm";
const UTM_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_term",
  "utm_content",
] as const;

type UtmParams = Partial<Record<(typeof UTM_PARAMS)[number], string>>;

export function captureUtms(): void {
  if (typeof window === "undefined") return;
  const params = new URLSearchParams(window.location.search);
  const captured: UtmParams = {};
  let hasUtm = false;

  UTM_PARAMS.forEach((key) => {
    const value = params.get(key);
    if (value) {
      captured[key] = value;
      hasUtm = true;
    }
  });

  if (hasUtm) {
    try {
      localStorage.setItem(UTM_STORAGE_KEY, JSON.stringify(captured));
    } catch {}

    try {
      const raw = localStorage.getItem(LATEST_UTM_STORAGE_KEY);
      const previous = raw ? (JSON.parse(raw) as UtmParams) : {};
      localStorage.setItem(
        LATEST_UTM_STORAGE_KEY,
        JSON.stringify({ ...previous, ...captured }),
      );
    } catch {}
  }
}

export function getStoredUtms(): UtmParams {
  if (typeof window === "undefined") return {};
  try {
    const raw = localStorage.getItem(UTM_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as UtmParams) : {};
  } catch {
    return {};
  }
}

export function getLatestUtms(): UtmParams {
  if (typeof window === "undefined") return {};
  try {
    const raw = localStorage.getItem(LATEST_UTM_STORAGE_KEY);
    return raw ? (JSON.parse(raw) as UtmParams) : {};
  } catch {
    return {};
  }
}
